/** How long the "secure checkout" state shows before the browser leaves for Stripe (KAN-852). No artificial delay beyond this. */
export const HANDOFF_MS = 700;
/** If the browser has not left by now, the hand-off state is cleared and the card is usable again. */
export const HANDOFF_FALLBACK_MS = 10000;
